import { aboutContent } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
            <div className="flex-1">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">{aboutContent.title}</h2>
              {aboutContent.desc.split('\n\n').map((p, i) => (
                <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">{p}</p>
              ))}
            </div>
            <div className="w-full lg:w-80 shrink-0">
              <img
                src={aboutContent.image}
                alt="关于妖精动漫"
                className="w-full h-auto rounded-2xl object-cover"
                width={640}
                height={420}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}